import React, { Component } from 'react';

class RefundPolicyPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="page refund-page">
        <div className="tos-hero">
          <div className="container">
            <p className="tos-eyebrow">Jason's Wine &amp; Spirits</p>
            <h1 className="page-title">Returns &amp; Refunds Policy</h1>
            <p className="tos-updated"><strong>Last Updated:</strong> 14 Dec 2025</p>
          </div>
        </div>

        <div className="container">
          <div className="terms-card">
            <p className="lead-text">
              Because Jason's Wine and Spirits sells alcoholic beverages, returns and refunds are subject to strict
              regulations and practical limits. This Returns &amp; Refunds Policy should be read together with our Terms
              of Use, Shipping &amp; Delivery Policy, and Privacy Policy.
            </p>

            <div className="terms-section">
              <h3>1. GENERAL POLICY</h3>
              <p>We want you to be satisfied with your purchase. However, due to alcohol regulations and product safety concerns:</p>
              <ul>
                <li>We generally cannot accept returns of alcoholic beverages once they have left our premises, except where required by law or as described in this Policy.</li>
                <li>For non-alcohol items (e.g., merchandise, glassware, accessories), different rules may apply (see Section 4).</li>
                <li>We reserve the right to handle each situation on a case-by-case basis, consistent with applicable law.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>2. ORDER ISSUES: DAMAGED, DEFECTIVE, OR INCORRECT ITEMS</h3>
              <h4>2.1 Damaged in Transit</h4>
              <p>If your order arrives with visible damage (e.g., broken bottles, leaking packages):</p>
              <ul>
                <li>If possible, ask the driver or carrier to note the damage at the time of delivery.</li>
                <li>Take clear photos of the damage (bottles, packaging, shipping label).</li>
                <li>Contact us at order@jasonsliquor.com within [X] days of delivery with:
                  <ul>
                    <li>Order number</li>
                    <li>Description of the issue</li>
                    <li>Photos of the damage</li>
                  </ul>
                </li>
              </ul>
              <p>Once we review your claim, we may, at our discretion and subject to applicable law:</p>
              <ul>
                <li>Replace the damaged items;</li>
                <li>Issue a refund or store credit; or</li>
                <li>Offer another appropriate remedy.</li>
              </ul>

              <h4>2.2 Defective or Spoiled Products</h4>
              <p>If you believe a product is defective (e.g., cork taint or similar quality issue):</p>
              <ul>
                <li>Please save the bottle (even if opened) and contact us at order@jasonsliquor.com within [X] days of purchase or delivery.</li>
                <li>We may ask you to bring the item back to the store or provide photos and a description.</li>
              </ul>
              <p>Where permitted by law and in our discretion, we may:</p>
              <ul>
                <li>Replace the product with the same or similar item;</li>
                <li>Issue a refund or store credit; or</li>
                <li>Decline the request if the issue appears to be related to storage, handling, or factors outside our control.</li>
              </ul>

              <h4>2.3 Incorrect Items</h4>
              <p>If you receive the wrong product or quantity:</p>
              <ul>
                <li>Contact us at order@jasonsliquor.com within [X] days of delivery.</li>
                <li>We will work with you to correct the order, which may include:
                  <ul>
                    <li>Exchanging the incorrect item</li>
                    <li>Picking up the incorrect product and delivering the correct one</li>
                    <li>Issuing a refund or store credit for the incorrect item</li>
                  </ul>
                </li>
              </ul>
              <p className="note-block">Customize: Pick your real timeframe (e.g., 3–7 days) and use it consistently.</p>
            </div>

            <div className="terms-section">
              <h3>3. CHANGE OF MIND / CUSTOMER REMORSE</h3>
              <p>Because of alcohol regulations and product integrity:</p>
              <ul>
                <li>We do not generally accept returns or issue refunds if you simply change your mind, dislike a product after opening, or order the wrong item without contacting us in time to change the order.</li>
                <li>In exceptional cases and at our sole discretion, we may allow an exchange or store credit for unopened, resaleable products within a specified period. Additional conditions and fees (including restocking fees) may apply.</li>
                <li>Please contact us before bringing any items back to the store so we can confirm if a return or exchange is permitted.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>4. NON-ALCOHOL MERCHANDISE (GLASSWARE, ACCESSORIES, ETC.)</h3>
              <p>For non-alcohol products (such as glassware, bar tools, merchandise, etc.):</p>
              <ul>
                <li>We may accept returns or exchanges of unopened and unused items in their original packaging within [X] days of purchase or delivery, with a valid receipt or proof of purchase.</li>
                <li>Items that show signs of use, wear, damage, or missing components may not be eligible for return.</li>
                <li>Some items may be final sale and not eligible for return or refund; this will be indicated where possible.</li>
                <li>Refunds for eligible returns of merchandise are typically issued to the original form of payment, minus any shipping or handling charges, unless otherwise stated.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>5. FAILED DELIVERIES, REFUSED ORDERS &amp; RESTOCKING FEES</h3>
              <p>As described in our Shipping &amp; Delivery Policy and Terms of Use, if an order is returned to us or cannot be completed for reasons such as:</p>
              <ul>
                <li>Recipient unavailable at delivery address;</li>
                <li>Failure to provide valid ID (21+);</li>
                <li>Recipient appears intoxicated;</li>
                <li>Incorrect or incomplete address provided;</li>
                <li>Order not picked up within specified time; or</li>
                <li>Other circumstances outside our control,</li>
              </ul>
              <p>we may:</p>
              <ul>
                <li>Treat the order as canceled; and</li>
                <li>Charge a non-refundable restocking fee of twenty dollars ($20.00).</li>
              </ul>
              <p>Any refund issued in such cases may:</p>
              <ul>
                <li>Exclude original shipping or delivery fees; and</li>
                <li>Be reduced by the restocking fee and any return shipping charges incurred by us.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>6. REFUND METHOD &amp; TIMING</h3>
              <p>When we approve a refund (whether full or partial), we will:</p>
              <ul>
                <li>Issue the refund to the original form of payment, where possible; or</li>
                <li>Offer store credit if original refund is not possible or if you prefer that option.</li>
              </ul>
              <p>Refund timing:</p>
              <ul>
                <li>Once processed on our end, it may take [X–Y business days] for the refund to appear on your bank or card statement, depending on your financial institution.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>7. HOW TO REQUEST A RETURN OR REFUND</h3>
              <p>To report an issue or request a return/refund, please contact us with:</p>
              <ul>
                <li>Your name</li>
                <li>Order number</li>
                <li>Date of purchase</li>
                <li>A clear description of the issue</li>
                <li>Photos where applicable (damage, incorrect items, etc.)</li>
              </ul>
              <p>Contact:</p>
              <ul>
                <li>Email: order@jasonsliquor.com</li>
                <li>Phone: (213) 485-9463</li>
                <li>Address (for in-person assistance): 828 S. Main Street, Los Angeles, CA 90014</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>8. POLICY UPDATES</h3>
              <p>We may update this Returns &amp; Refunds Policy from time to time. Any changes will be posted on our Site and/or App with an updated “Last Updated” date. Your continued use of our Services and your purchases following the posting of changes means you accept the updated policy.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RefundPolicyPage;



// WEBPACK FOOTER //
// ./src/containers/tos/RefundPolicyPage.js